module.exports = __webpack_public_path__ + "img/banner-kiki-mobile.2d7cddb1.png";